// debugStyled.ts
import { styled as muiStyled } from '@mui/material/styles'

// Only filter undefined/null/false, leave 0/'' intact
const isValidArg = (a: any) => a !== undefined && a !== null && a !== false

export function styled(component: any, options?: any) {
  const base = options ? muiStyled(component, options) : muiStyled(component)

  return (...args: any[]) => {
    if (args.some(a => !isValidArg(a))) {
      // eslint-disable-next-line no-console
      console.warn(
        '[styled:debug] undefined/false arg for',
        component?.displayName || component?.name || component,
        args
      )
    }
    return (base as any)(...args.filter(isValidArg))
  }
}
